<template>
    <div class="bloc-search-sms">
        <div
        :class="{
            'col-md-12 loop-sms': pageName !== 'Contact-history',
            'col-lg-6 col-md-7':  pageName !== 'sms-conv' && pageName !== 'Contact-history',
            'col-lg-10 col-md-7': showContactInfoSection
        }"
            class="col-7 text-right mb-1 col-search-conv d-flex flex-wrap justify-content-left align-items-center"
            id="col-search-sms"
        >
            <font-awesome-icon class="fa-search text-grey " :icon="['fa', 'search']" @click="showInputSearch()"/>
            <transition name="fade">
                <input v-if="searchShow"
                    type="search" ref="searchSmsInput" id="searchSmsInput"
                    class="search-contact search-conv-input form-control fs-14"
                    :class="{
                        fadeIn: searchShow,
                        'search-conv-user-input': currentSection === 'sms-user',
                        'search-conv-wait-input': currentSection === WITHOUT_USERS_CONVERSATIONS_SECTION,
                        'search-contact-input': pageName === 'Contact-history'
                    }"
                    v-bind:placeholder="$t('search-conv')"
                    v-on:keyup="changeTxtSearch()"
                    v-on:search="clearTxtSearch()"
                    v-model="search">
            </transition>
        </div>
        <div id="col-search-results" class="col d-flex flex-wrap justify-content-between text-left mt-0 pt-0 col-results"
            v-if="search!== '' && this.searchShow"
            :class="{
                'col-md-12 bloc-result': currentSection === WITHOUT_USERS_CONVERSATIONS_SECTION,
                'col-md-12 bloc-result-contact': pageName === 'Contact-history',
                'col-lg-6 col-md-7 bloc-result-user': currentSection === CURRENT_USER_CONVERSATIONS_SECTION || pageName === 'sms-conv'
            }"
        >
            <label class="search-sms-text" v-if="searchCountResult > 0">
                <template v-if="arrowBtnActivated"> {{ $t('Result') }} {{elemHighlighted}} {{ $t('of') }} {{searchCountResult}}</template>
                <template v-else>{{searchCountResult}} {{ searchCountResult > 1 ? $t('results') : $t('result') }}</template>
            </label>
            <label class="search-sms-text font-nunito-italic" v-else>{{ $t('no-results-found') }}</label>
            <label class="search-sms-text" :class="{'search-arrows': pageName === 'Contact-history', 'bloc-arrows': pageName !== 'Contact-history'}" v-if="searchCountResult > 0">
                <font-awesome-icon  :class="{ 'arrow-disabled' : elemHighlighted === 0 }" class="text-black mr-1" :icon="['fas', 'chevron-up']" @click="previousResultClick()"/>
                <font-awesome-icon :class="{ 'arrow-disabled' : elemHighlighted === searchCountResult }" class="text-black" :icon="['fas', 'chevron-down']" @click="nextResultClick()"/>
            </label>
        </div>
    </div>
</template>

<script>
export default {
    emits: ['searchChange', 'searchClear', 'nextResultClick', 'previousResultClick'],

    props: ['searchCountResult', 'elemHighlighted', 'resetSearch', 'arrowBtnActivated', 'pageName', 'showContactInfoSection', 'currentSection'],

    watch: {
        resetSearch () {
            this.showInputSearch();
        }
    },

    data () {
        const WITHOUT_USERS_CONVERSATIONS_SECTION = 'without-users-conversartions';
        const CURRENT_USER_CONVERSATIONS_SECTION  = 'current-user-conversartions';
        return {
            WITHOUT_USERS_CONVERSATIONS_SECTION,
            CURRENT_USER_CONVERSATIONS_SECTION,
            search:     '',
            searchShow: false
        };
    },

    methods: {
        /**
         * Text Search changed
         */
        changeTxtSearch () {
            this.$emit('searchChange', this.search);
        },

        /**
         * Show the previous result
         */
        previousResultClick () {
            this.$emit('previousResultClick');
        },

        /**
         * Show the next result
         */
        nextResultClick () {
            this.$emit('nextResultClick');
        },

        /**
         * Clear the Search input
         */
        clearTxtSearch () {
            this.$emit('searchClear');
        },

        /**
         * Show the input of search
         */
        showInputSearch () {
            this.searchShow = !this.searchShow;
            if (!this.searchShow) {
                this.search = '';
                this.$emit('searchClear');
            } else {
                const searchDelay = 500;
                setTimeout(() => {
                    this.$refs.searchSmsInput?.focus();
                    this.$emit('searchClear');
                }, searchDelay);
            }
        }
    }
};
</script>
